var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._v(" Sorry, page not found!\n  "),_c('router-link',{staticClass:"dashboard-link",attrs:{"to":"/dashboard/customers"}},[_vm._v(" Go to dashboard ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }